export enum RegistrationAddressTypeEnum {
    RESIDENTIAL = 'Residencial',
    COMMERCIAL = 'Comercial',
    COLLECTION = 'Cobrança',
    DELIVERY = 'Entrega'
}

export type RegistrationAddressType = 'RESIDENTIAL' | 'COMMERCIAL' | 'COLLECTION' | 'DELIVERY';
